import {
    CallStatusEnum,
    DULUX__EVENT__CALLS__CALL_STATUS__COLUMN_ID,
    DULUX__EVENT__CALLS__CREATED_BY_ROLE__COLUMN_ID,
    DULUX__EVENT__CALLS__EVENT_OWNER__COLUMN_ID,
    DULUX__EVENT__CALLS__SCHEDULE_DATE__COLUMN_ID,
    DuluxEventTypes,
} from "~/domainModels/workspaceSpecific/dulux";
import {
    buildScheduleCallTimeSlotOptions,
    combineScheduleDateAndTimeSlot,
} from "~/domainModels/scheduleCall/scheduleCallShared";
import type {ScheduleCallStrategy} from "~/domainModels/scheduleCall/scheduleCallStrategy";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {toIso8601FromIstSafe} from "~/utilities/utilities";

export const duluxScheduleCallStrategy: ScheduleCallStrategy = {
    callEventTemplateId: DuluxEventTypes.Calls as Uuid,
    supportsInlineModal: true,
    usesDuluxBackendOrchestration: true,
    resolveCallEventTemplate: (eventTemplates) =>
        eventTemplates.find((template) => template.id === (DuluxEventTypes.Calls as Uuid)),
    buildCallTimeSlotOptions: buildScheduleCallTimeSlotOptions,
    combineDateAndTimeSlot: combineScheduleDateAndTimeSlot,
    buildSubmitPayload: ({scheduledOnIso, workspaceUserId, workspaceUserTemplateId}) => {
        const scheduleDateIso = toIso8601FromIstSafe(scheduledOnIso) ?? scheduledOnIso;

        return {
            journeyUpdate: null,
            eventAdditionalColumnValues: {
                [DULUX__EVENT__CALLS__CALL_STATUS__COLUMN_ID]: CallStatusEnum.SCHEDULED,
                [DULUX__EVENT__CALLS__CREATED_BY_ROLE__COLUMN_ID]: workspaceUserTemplateId,
                [DULUX__EVENT__CALLS__EVENT_OWNER__COLUMN_ID]: workspaceUserId,
                [DULUX__EVENT__CALLS__SCHEDULE_DATE__COLUMN_ID]: scheduleDateIso,
            },
        };
    },
};

export const duluxListScheduleCallStrategy = duluxScheduleCallStrategy;
